<div class="carousel-wrapper">
  <swiper *ngIf="!!slides.length" [config]="swiperConfig">
    <ng-template swiperSlide *ngFor="let slide of slides; let i = index">
      <app-live-banner [banner]="slide" [isLive]="false"></app-live-banner>
      <button class="arrow-icon left">
        <i class="bi bi-arrow-left"></i>
      </button>
      <button class="arrow-icon right">
        <i class="bi bi-arrow-right"></i>
      </button>
    </ng-template>
  </swiper>
</div>
